// extracted by mini-css-extract-plugin
export var blue = "_33-f";
export var brand = "_33-b";
export var darkGrey = "_33-e";
export var disabled = "_33-4";
export var disabledSubtle = "_33-5";
export var error = "_33-6";
export var green = "_33-g";
export var grey = "_33-d";
export var icon = "_33-0";
export var inherit = "_33-a";
export var lightGrey = "_33-c";
export var orange = "_33-i";
export var pink = "_33-k";
export var primary = "_33-1";
export var purple = "_33-l";
export var red = "_33-j";
export var secondary = "_33-2";
export var success = "_33-9";
export var tertiary = "_33-3";
export var warning = "_33-7";
export var warningSecondary = "_33-8";
export var white = "_33-m";
export var yellow = "_33-h";